import { useState } from "react";
import { Props_SnippetVideo } from "./Video.props";

const convertIframeUrl = (url: string): string => {
    let newUrl = url;

    // Handle YouTube URLs
    if (url.includes("watch?v=")) {
        newUrl = url.replace("watch?v=", "embed/");
    } else if (url.includes("youtu.be")) {
        newUrl = url.replace("youtu.be/", "youtube.com/embed/");
    }

    // Handle Vimeo URLs
    if (url.includes("vimeo.com")) {
        const match = url.match(/vimeo\.com\/(\d+)/);
        if (match) {
            newUrl = `https://player.vimeo.com/video/${match[1]}`;
        }
    }

    // Add autoplay for all URLs if not already present
    if (!newUrl.includes("autoplay=1")) {
        newUrl = `${newUrl}${newUrl.includes("?") ? "&" : "?"}autoplay=1`;
    }
    
    return newUrl;
};

const Video = (props: Props_SnippetVideo) => {

    const {
        videoTitle,
        contentSectionOptions,
        videoText,
        videoContentLink,
        videoDetails,
        videoThumbnail,
    } = props;

    const showContentSection = contentSectionOptions?.showContentSection?.value === "true";
    const fullWidth = videoDetails?.videoFullWidth?.value === "true";
    const position = contentSectionOptions?.contentSectionPosition?.value;
    const showTitle = videoTitle?.showTitle?.value === "true";
    const showLink = videoContentLink?.showLink?.value === "true";
    const convertedUrl = convertIframeUrl(videoDetails?.videoUrl?.value ?? "");
    const [playing, setPlaying] = useState(false);
    const videoSectionClassName = "snippet-video__video-section" + (fullWidth ? "" : " snippet-video__video-section--not-fullwidth") + (playing ? " snippet-video__video-section--playing" : "");

    return (
        <section className="snippet-video">
            <div className={"snippet-video__container snippet-video__container--" + position}>
                <div className={videoSectionClassName}>
                    {!playing && ( <button className="snippet-video__play-button play-button" aria-label="play" onClick={() => setPlaying(true)}></button>
                    )}
                    {!playing && videoThumbnail?.image?.value && (
                        <figure className="snippet-video__image-container">
                            <img
                                src={videoThumbnail?.image?.value}
                                alt="video thumbnail"
                                className="snippet-video__image"
                                loading="lazy"
                                width="1920"
                                height="1080"
                            />
                        </figure>
                    )}
                    {playing && (
                        <iframe
                            width="560"
                            height="315"
                            src={convertedUrl}
                            title="YouTube video player"
                            loading="lazy"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            className="snippet-video__video"
                            allowFullScreen={true}
                        ></iframe>
                    )}
                </div>
                <div className="snippet-video__content-section">
                    {videoTitle?.text?.value && (
                        <h2 className={"snippet-video__title" + (showTitle ? "" : " accessible-heading")}>
                            {videoTitle?.text?.value}
                        </h2>
                    )}

                    {showContentSection && (
                        <div className="snippet-video__inner-content">
                            <p className="snippet-video__text">
                                {videoText?.text?.value}
                            </p>

                            {showLink && (
                                <a href={videoContentLink?.linkUrl?.value} className="snippet-video__cta attrax-button" aria-label={videoContentLink?.linkText?.value}>
                                    {videoContentLink?.linkText?.value}
                                </a>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Video;
